import {layoutModuleMap} from './constants';

export const getFormSubmitData = data => {
    const {
        stitchLayout,
        sizeControl,
        stitchTargetCount,
        stitchSpace
    } = data;
    let params = {};

    const getSizeParams = () => {
        let params = {width: 0, height: 0};
        if (sizeControl.type === 'choose') {
            sizeControl.value.ratio ? params.ratio = `RATIO_${sizeControl.value.ratio.replace(/:/g, '_')}` : '';
            const sizeList = sizeControl.value.dimension.split('*');
            params.width = +sizeList[0];
            params.height = +sizeList[1];
        }
        else if (sizeControl.type === 'custom') {
            params.width = +sizeControl.value.customWidth;
            params.height = +sizeControl.value.customHeight;
        }
        return params;
    };

    const getLayoutParams = () => {
        const {type, value} = stitchLayout;
        let params = {
            layoutNum: +type,
            itemSize: value?.itemSize || []
        };
        // 如果之前的数据没有存下来，则根据静态配置重新获取一下
        if (params.itemSize.length < 1) {
            let moduleList = layoutModuleMap[type];
            let chooseItem = moduleList.find(item => item.key === value.chooseValue);
            params.itemSize = chooseItem?.itemSize || [];
        }
        return params;
    };

    const getImagesParams = () => {
        const uploadList = stitchTargetCount.uploadList || [];
        const itemSize = stitchLayout?.value?.itemSize || [];
        let targetCount = 0;
        if (itemSize.length) {
            targetCount = Math.floor(uploadList.length / itemSize.length);
        }
        let params = {
            targetCount,
            uploadList
        };
        return params;
    };

    params = {
        ...getSizeParams(),
        ...getLayoutParams(),
        ...getImagesParams(),
        space: +stitchSpace.value || 0,
        imageGenerateType: 'PUZZLE_IMAGE'
    };

    return params;
};

// 把根据画布和布局信息计算每个图片坐标的逻辑移到这里，方便多处使用以及逻辑统一
export const getImagePositionInfo = ({canvasStyle, imageItem, sizeParam, space}) => {
    const {width: canvasWidth, height: canvasHeight} = canvasStyle;
    const {widthFac, widthSpaceFac, heightFac, heightSpaceFac, leftFac, topFac,
        leftSpaceFac, topSpaceFac} = sizeParam;
    const {originContainerWidth, originContainerHeight} = imageItem;
    const containerWidth = Math.ceil(widthFac * (canvasWidth - widthSpaceFac * space));
    const containerHeight = Math.ceil(heightFac * (canvasHeight - heightSpaceFac * space));
    const {originWidth, originHeight} = imageItem;
    // 有原图尺寸优先使用
    const imageWidth = originWidth || imageItem.width;
    const imageHeight = originHeight || imageItem.height;
    const ratioItem = imageWidth / imageHeight;
    const ratioContainer = containerWidth / containerHeight;
    let targetWidth = containerWidth;
    let targetHeight = containerHeight;
    if (ratioItem > ratioContainer) {
        targetWidth = containerHeight * ratioItem;
    }
    else {
        targetHeight = containerWidth / ratioItem;
    }
    let bgPosX = ratioItem > ratioContainer ? Math.floor((targetWidth - containerWidth) / 2) : 0;
    let bgPosY = ratioItem > ratioContainer ? 0 : Math.floor((targetHeight - containerHeight) / 2);
    if (bgPosX !== 0) {
        if (!isNaN(imageItem.bgPosXNew)) {
            bgPosX = imageItem.bgPosXNew;
        }
    }
    if (bgPosY !== 0) {
        if (!isNaN(imageItem.bgPosYNew)) {
            bgPosY = imageItem.bgPosYNew;
        }
    }
    const left = (canvasWidth - space * widthSpaceFac) * leftFac + space * leftSpaceFac;
    const top = (canvasHeight - space * heightSpaceFac) * topFac + space * topSpaceFac;
    const imageInfo = {
        // 位置(absolute) left top
        // 宽高(absolute) width height 需要和选择的尺寸进行换算
        // bgPosition
        url: imageItem.url,
        containerWidth,
        containerHeight,
        width: containerWidth,
        height: containerHeight,
        targetWidth,
        targetHeight,
        originWidth: imageWidth,
        originHeight: imageHeight,
        left,
        top,
        bgPosX,
        bgPosY,
        bgPosXNew: imageItem.bgPosXNew,
        bgPosYNew: imageItem.bgPosYNew,
        originContainerWidth,
        originContainerHeight
    };
    return imageInfo;
};
